/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {TableProducts} from '../storeServices/components/TableProducts'
import {TableTypeServices} from '../storeServices/components/TableTypeServices'
import catalogStyles from './catalogo.module.css'
import listLayoutStyles from '../components/ListTableLayout/listTableLayout.module.css'

const catalogoBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

type CatalogTab = 'SERVICO' | 'PRODUTO'

const CatalogoPage: FC = () => {
  const [selectorTable, setSelectorTable] = useState<CatalogTab>('SERVICO')

  return (
    <div className={`card ${catalogStyles.catalogCard} ${listLayoutStyles.listCard}`}>
      <div className={catalogStyles.catalogHeader}>
        <div className={catalogStyles.catalogIntro}>
          <h2 className={catalogStyles.catalogTitle}>
            {selectorTable === 'SERVICO' ? 'Serviços disponíveis' : 'Controle de estoque'}
          </h2>
          <p className={catalogStyles.catalogSubtitle}>
            {selectorTable === 'SERVICO'
              ? 'Organize preços, fotos e filiais dos serviços oferecidos.'
              : 'Acompanhe quantidade, preços e fotos dos produtos em estoque.'}
          </p>
        </div>

        <div className={catalogStyles.segmentedControl} role='group' aria-label='Tipo de catálogo'>
          <button
            type='button'
            className={`${catalogStyles.segmentBtn} ${
              selectorTable === 'SERVICO' ? catalogStyles.segmentBtnActive : ''
            }`}
            onClick={() => setSelectorTable('SERVICO')}
          >
            Serviços
          </button>
          <button
            type='button'
            className={`${catalogStyles.segmentBtn} ${
              selectorTable === 'PRODUTO' ? catalogStyles.segmentBtnActive : ''
            }`}
            onClick={() => setSelectorTable('PRODUTO')}
          >
            Produtos
          </button>
        </div>
      </div>

      <div className={catalogStyles.catalogDivider} />

      <div className={catalogStyles.catalogContent}>
        {selectorTable === 'PRODUTO' && (
          <TableProducts
            className={listLayoutStyles.listCard}
            refresh={() => {}}
            refreshPage={false}
            setRefreshPage={() => {}}
          />
        )}

        {selectorTable === 'SERVICO' && (
          <TableTypeServices
            className={listLayoutStyles.listCard}
            refresh={() => {}}
            refreshPage={false}
            setRefreshPage={() => {}}
          />
        )}
      </div>
    </div>
  )
}

const CatalogoWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={catalogoBreadcrumbs}>Catálogo</PageTitle>
      <CatalogoPage />
    </>
  )
}

export {CatalogoWrapper}
